import { HttpClient } from '@huspy/forge/shared';
import { BaseFetcher } from './fetchers';

export default new HttpClient(new BaseFetcher());
